export default __webpack_public_path__ + "static/media/9c9994c305c33f2d.4c13feab6c92c601fed96a8bed480829.svg";